import styled from 'styled-components';

export const SrpRightBlockLayoutDiv = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  width:75%;
  padding-left:${props.theme.spacing.base};
  flex-direction:column;
`,
);


export const SortByContainer = styled.div(`
  display:flex;
  justify-content:space-between;
  align-items:center;
`)